export const MobileCardsQuizIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                d="M11.25 15.2882L9.79312 13.8314L9 14.6245L11.25 16.8745L15.75 12.3745L14.9569 11.5814L11.25 15.2882Z"
                fill="white"
            />
            <path
                d="M5.625 15V4.875H12.375V9.9375H13.5V2.625C13.5 2.32663 13.3815 2.04048 13.1705 1.8295C12.9595 1.61853 12.6734 1.5 12.375 1.5H5.625C5.32663 1.5 5.04048 1.61853 4.82951 1.8295C4.61853 2.04048 4.5 2.32663 4.5 2.625V15C4.5 15.2984 4.61853 15.5845 4.82951 15.7955C5.04048 16.0065 5.32663 16.125 5.625 16.125H7.875V15H5.625ZM5.625 2.625H12.375V3.75H5.625V2.625Z"
                fill="white"
            />
        </svg>
    );
};
